import { graphql } from '../../gql';

export default graphql(`
    mutation GenerateUserTOTP($input: GenerateUserTOTPInput!) {
        generateUserTotp(input: $input) {
            img
        }
    }
`);
